export const ROUTES = {
  HOME: "HOME",
  HOME_DE: "HOME_DE",
  WHAT: "WHAT",
  WHAT_DE: "WHAT_DE",
  WORKS: "WORKS",
  WORKS_DE: "WORKS_DE",
  FOUR_HUNDRED_FOUR: "FOUR_HUNDRED_FOUR",
  BLOG: "BLOG",
  INCUBATOR: "INCUBATOR",
  NEARSHORING: "NEARSHORING",
  NEARSHORING_DE: "NEARSHORING_DE",
  NEARSHORING_EN: "NEARSHORING_EN",
};

interface IPath {
  [route: string]: string;
}
export const PATHS: IPath = {
  HOME: "",
  HOME_DE: "de",
  WHAT: "what",
  WHAT_DE: "was",
  WORKS: "works",
  WORKS_DE: "projekte",
  FOUR_HUNDRED_FOUR: "404",
  BLOG: "blog",
  INCUBATOR: "incubator",
  NEARSHORING: "nearshoring",
  NEARSHORING_DE: "nearshoring-de",
  NEARSHORING_EN: "nearshoring-en",
};
